import { isNil } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { Loadable } from '@shared/components/loading';
import { CreateQrCode } from '../types';
import { useCreateRemoteQrCode } from './useCreateRemoteQrCode';
import { usePrepareRemoteFileForSharing } from './usePrepareRemoteFileForSharing';

export function useCreateQrCode(): CreateQrCode {
  const [response, setResponse] = useState<Loadable<string> | undefined>();
  const { response: createResponse, createRemoteQrCode } = useCreateRemoteQrCode();
  const { response: prepareResponse, prepareRemoteFileForSharing } =
    usePrepareRemoteFileForSharing();

  const createQrCode = useCallback(
    (url: string) => {
      setResponse({ state: 'loading' });
      createRemoteQrCode(url);
    },
    [createRemoteQrCode],
  );

  useEffect(() => {
    if (isNil(createResponse) || createResponse.state === 'loading') {
      return;
    }

    if (createResponse.state === 'success') {
      prepareRemoteFileForSharing(createResponse.data, 'QR Code');
    } else if (createResponse.state === 'failure') {
      setResponse({ state: 'failure', error: createResponse.error });
    }
  }, [createResponse, prepareRemoteFileForSharing]);

  useEffect(() => {
    if (isNil(prepareResponse) || prepareResponse.state === 'loading') {
      return;
    }

    setResponse(prepareResponse);
  }, [prepareResponse]);

  return { response, createQrCode };
}
